module.exports = __webpack_public_path__ + "static/media/logo.677cba2d.png";